var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-5 w-full text-center"},[_c('img',{staticClass:"max-w-full h-auto inline-block dark:invert dark:brightness-90",attrs:{"alt":"元素周期表","src":_vm.periodicTableImage}})])
}
var staticRenderFns = []

export { render, staticRenderFns }